import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../shared/LanguageService';
import CreateProductGroupModal from './CreateProductGroupModal';
import EditProductGroupModal from './EditProductGroupModal';
import ProductGroupList from './list/ProductGroupList';
import * as Actions from './Actions';
import IProductGroup from './IProductGroup';
import IProductGroupListItem from './list/IProductGroupListItem';
import { Button } from 'react-bootstrap';
import notify from '../../shared/feedback/notifications';
import LogsModal from '../logs/LogsModal';

class ProductGroupsPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            shouldShowCreateModal: false,
            shouldShowEditModal: false,
            shouldShowLogsModal: false
        };

        this.openCreateModal = this.openCreateModal.bind(this);
        this.closeCreateModal = this.closeCreateModal.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.openLogsModal = this.openLogsModal.bind(this);
        this.closeLogsModal = this.closeLogsModal.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.loadProductGroups().catch((errorResponse: any) => {
            errorResponse.errors.forEach((e: any) => {
                notify.failure(Translate(e.value as string));
            });
        });
    }

    openCreateModal() {
        this.setState({ shouldShowCreateModal: true });
    }

    closeCreateModal() {
        this.setState({ shouldShowCreateModal: false });
    }

    onEdit(item: IProductGroupListItem) {
        this.setState({
            editProductGroupId: item.id,
            shouldShowEditModal: true
        });
    }

    closeEditModal() {
        this.setState({ shouldShowEditModal: false });
    }

    openLogsModal(item: IProductGroupListItem) {
        this.setState({
            logProductGroupId: item.id,
            shouldShowLogsModal: true
        });
    }

    closeLogsModal() {
        this.setState({ shouldShowLogsModal: false });
    }

    onDelete(item: IProductGroupListItem) {
        this.props.actions
            .deleteProductGroup(item.id)
            .then(notify.success(Translate('product-groups/notification/product-group-deleted')))
            .catch((errorResponse: any) => {
                errorResponse.errors.forEach((e: any) => {
                    notify.failure(Translate(e.value as string));
                });
            });
    }

    render() {
        return (
            <div>
                <h1>{Translate('product-groups/page/title/product-groups')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('product-groups/page/button-label/add-new-product-group')}
                </Button>

                <ProductGroupList
                    items={this.props.productGroups}
                    onDelete={this.onDelete}
                    onEdit={this.onEdit}
                    showLogs={this.openLogsModal}
                />

                {this.state.shouldShowCreateModal && (
                    <CreateProductGroupModal
                        shouldShowModal={this.state.shouldShowCreateModal}
                        closeModal={this.closeCreateModal}
                    />
                )}

                {this.state.shouldShowEditModal && (
                    <EditProductGroupModal
                        productGroupId={this.state.editProductGroupId}
                        shouldShowModal={this.state.shouldShowEditModal}
                        closeModal={this.closeEditModal}
                    />
                )}

                {this.state.shouldShowLogsModal && (
                    <LogsModal
                        id={this.state.logProductGroupId}
                        type="ProductGroupId"
                        shouldShowModal={this.state.shouldShowLogsModal}
                        closeModal={this.closeLogsModal}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        productGroups: state.productGroups.list.sort(
            (a: IProductGroupListItem, b: IProductGroupListItem): number => (a.id < b.id ? -1 : 1)
        )
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            loadProductGroups: () => dispatch(Actions.loadProductGroups()),
            deleteProductGroup: (id: number) => dispatch(Actions.deleteProductGroup(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductGroupsPage);
